import { useState } from "react";
import { Login } from "./pages/Login";
import { ForgotPassword } from "./pages/ForgotPassword";
import { ResetPassword } from "./pages/ResetPassword";
import { Layout } from "./layouts/layout";
import { CustomerManagement } from "./pages/customer/CustomerManagement";
import { CustomerInfomation } from "./pages/customer/CustomerInfomation";
import { PackageManagement } from "./pages/package/PackageManagement";
import { PackageInfomation } from "./pages/package/PackageInfomation";
import { UserAdminManagement } from "./pages/settings/UserAdminManagement";
import { UserAdminInfomation } from "./pages/settings/UserAdminInfomation";
import { Routes, Route, Navigate } from "react-router-dom";

import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import { NotFound } from "./pages/NotFound";
import { BusinessDetails } from "pages/customer/business-settings/BusinessDetails";

function App() {
  const [selectbranchID, setSelectBranchID] = useState(1);
  const checkToken = () => {
    const token = localStorage.getItem("accessToken");
    return !!token;
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          checkToken() ? (
            <Navigate to="/customers" replace />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        }
      />
      <Route
        path="/reset-password"
        element={
          <PublicRoute>
            <ResetPassword />
          </PublicRoute>
        }
      />

      <Route
        element={
          <ProtectedRoute>
            <Layout
              setSelectBranchID={setSelectBranchID}
              selectbranchID={selectbranchID}
            />
          </ProtectedRoute>
        }
      >
        <Route path="/customers" element={<CustomerManagement />} />
        <Route path="/customer/manage" element={<CustomerInfomation />} />
        <Route
          path="/customer/manage/:customerID"
          element={<CustomerInfomation />}
        />
        <Route
          path="/customer/manage/:customerID/business/:businessID"
          element={<BusinessDetails />}
        />

        <Route path="/packages" element={<PackageManagement />} />
        <Route path="/package/manage" element={<PackageInfomation />} />
        <Route
          path="/package/manage/:packageID"
          element={<PackageInfomation />}
        />
        <Route path="/setting/users" element={<UserAdminManagement />} />
        <Route path="/setting/user/manage" element={<UserAdminInfomation />} />
        <Route
          path="/setting/user/manage/:adminID"
          element={<UserAdminInfomation />}
        />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
